import React from "react";
import ControlPlans from "./Control-plans/Control-plans";
import ControlProducts from "./Control-products/Control-products";
import "./Control-panel.css"; // Asegúrate de tener este archivo CSS para los estilos
import ControlSalesExpress from "./Control-sales-express/Control-sales-express";

const ControlPanel = () => {
  return (
    <div className="control-panel-container">
      <h1 className="title-module">Panel de control</h1>
      <ControlPlans/>
      <div class="light-divider"></div>
      <ControlProducts/>
      <div class="light-divider"></div>
      <ControlSalesExpress/>
    </div>
  );
};

export default ControlPanel;
